import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useAppDispatch, useAppSelector } from ".";
import { loginExe } from "../apis/auth";
import { setMemInfo } from "../redux/authSlice";
import { close } from "../redux/loginLayerSlice";

interface LoginInfo {
    memName: string;
    memPass: string;
    memKey: string;
}

const useLogin = () => {
    const dispatch = useAppDispatch();
    const memKey = useAppSelector(state => state.auth.memKey);
    return useMutation<AxiosResponse, Error, LoginInfo>(async (data) => await loginExe(data), {
        onSuccess: (data) => {
            if ("200" === data.data.resultCode) {
                dispatch(close())
                dispatch(setMemInfo({
                    memId: data.data.memId,
                    memName: data.data.memName,
                    memKey: memKey,
                }));
            } else {
                alert("인증 정보가 없습니다. 정보를 확인해 주세요.")
                return;
            }
        }
    });
}

export default useLogin;